let AuditRuleService = function ($http, $q, $rootScope, $sanitize) {

    var ruleArray = [];

    /**
     * Get the list of rules
     */

    let data = function () {
        var deferred = $q.defer();
        if (ruleArray.length === 0) {
            $http.defaults.headers.common['Authorization'] = 'Bearer ' + $rootScope.globals.currentUser.token;
            $http.get(WEBSERVICEURL + '/dataagility/api/service.ruleconfig')
                .then(function successCallback(response) {
                    angular.forEach(response.data, function (value, key) {
                        var sterilizedName = $sanitize(value['name']);
                        if (sterilizedName && ruleArray.indexOf(sterilizedName) === -1) {
                            ruleArray.push({ruleId: value['ruleId'], name: sterilizedName, auditTypeId: value.auditTypeId});
                        }
                    });
                    deferred.resolve(ruleArray);
                },
                function errorCallback(response) {
                  if (response.status === 401) {
                    window.location.replace(window.location.origin + '/login?logout=true');
                  }
                });
        } else {
            deferred.resolve(ruleArray);
        }
        return deferred.promise;
    }

    return { data };

};

export default AuditRuleService;



// WEBPACK FOOTER //
// ./client/app/common/services/auditRule.service.js